var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71 9.97092C3.71 6.50672 6.49437 3.71 9.91484 3.71C13.3353 3.71 16.1197 6.50672 16.1197 9.97092C16.1197 13.4351 13.3353 16.2318 9.91484 16.2318C6.49437 16.2318 3.71 13.4351 3.71 9.97092ZM9.91484 2C5.53723 2 2 5.57509 2 9.97092C2 14.3667 5.53723 17.9418 9.91484 17.9418C11.8307 17.9418 13.5857 17.257 14.9536 16.1184L20.5369 21.7461C20.8695 22.0813 21.4108 22.0834 21.746 21.7508C22.0813 21.4183 22.0834 20.8769 21.7508 20.5417L16.1433 14.8896C17.2 13.5341 17.8297 11.8255 17.8297 9.97092C17.8297 5.57509 14.2925 2 9.91484 2Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d7daddeaddd48c40d9971cc19b20e51b.svg";
export { ForwardRef as ReactComponent };